import customAxios from "../../customAxios";
import {DELETE_PARENT} from "../../routes";

const deleteSchool = async (userId: string) => {
  try {
    return (await customAxios.delete(DELETE_PARENT, {data: {userId}})).data;
  } catch (error: any) {
    console.log({DELETE_PARENT: error});
    return false;
  }
};

export default deleteSchool;
